// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"35":"84f0281b","545":"ea088a9b","633":"bfa26e32","768":"84f0281b","798":"bf8df5df"}[chunkId] + ".css";
};